import { render, staticRenderFns } from "./InvestorOnboardingIdentityVerification.vue?vue&type=template&id=f9252108&"
import script from "./InvestorOnboardingIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports